<template>
  <div class="modal fade" id="schedule-payment-modal" aria-hidden="true" aria-labelledby="exampleGrid" role="dialog" >
    <div class="modal-dialog modal-simple modal-lg modal-center">
      <div class="modal-content">
        <form autocomplete="off" @submit.prevent="editData ? updateSchedulePayment() : createSchedulePayment()">
          <div class="modal-header">
            <div class="container">
              <div class="row header">
                <div class="col-8">
                  <h4 class="modal-title">
                    {{ editData ? $t('automation.index.schedule_payment.update_schedule_payment') : $t('automation.index.schedule_payment.create_schedule_payment') }}
                  </h4>
                </div>
                <div class="col-4">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="closeScheduleModal()">
                    <span class="close-btn" aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-3">
                <div class="form-group">
                  <label for="schedule-payment-title" class="control-label">
                    {{ $t("automation.index.modal.title") }}
                  </label>
                  <span class="required">*</span>
                  <input id="schedule-payment-title" type="text" class="form-control" v-model="schedulePayment.title">
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label class="control-label">
                    {{ $t("automation.index.modal.this_rental") }}
                  </label>
                  <button class="btn btn-secondary btn-lg dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{ $t('automation.index.select_rentals') }}
                  </button>
                  <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                    <div class="checkbox-custom m-l-10 checkbox-primary">
                      <input type="checkbox" id="all-rentals" v-model="areAllRentalsChecked" @change="filterByRentals('all')" :disabled="isRentalAllDisabled()">
                      <label for="all-rentals">
                        {{ $t('automation.index.all') }}
                      </label>
                    </div>
                    <ul class="checkbox-custom m-l-30 checkbox-primary">
                      <ul v-for="group in groups" v-if="group.rentals.length > 0" class="checkbox-custom m-l-30 checkbox-primary" style="margin-left: 10px">
                        <input type="checkbox" @change="filterByRentals(group.id)" v-model="checkedGroups[group.id]" :id="group.name" :disabled="isGroupDisabled(group.id)">
                        <label :for="group.name">
                          <span class="rental-name">{{ group.name === 'others' ? $t('groups.others') : group.name }}</span>
                        </label>
                        <li v-for="rental in group.rentals" class="checkbox-custom m-l-10 checkbox-inline checkbox-primary dropdown-item">
                          <input type="checkbox" @change="filterByRentals()" v-model="checkedRentals[rental.id]" :id="rental.name" :disabled="isRentalDisabled(rental.id)">
                          <label :for="rental.name">
                            <span class="rental-name">{{ rental.name }}</span>
                          </label>
                        </li>
                      </ul>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label class="control-label">
                    {{ $t("automation.index.modal.this_channel") }}
                  </label>
                  <button class="btn btn-secondary btn-lg dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{ $t('automation.index.select_channels') }}
                  </button>
                  <div class="dropdown-menu rentals-list" aria-labelledby="navbarDropdown">
                    <div class="checkbox-custom m-l-10 checkbox-primary mb-5">
                      <input type="checkbox" v-model="areAllChannelsChecked" id="all" @change="filterByChannels('all')" :disabled="isChannelAllDisabled()">
                      <label for="all">{{ $t('automation.index.modal.all_channels') }}</label>
                    </div>
                    <ul class="checkbox-custom m-l-30 checkbox-primary m-10" id="user-channel-list">
                      <li v-for="channel in channels" class="checkbox-custom m-l-10 checkbox-primary d-flex align-items-center m-10">
                          <input type="checkbox" v-model="channel.is_checked" :id="channel.id" @change="filterByChannels(channel.id)" :disabled="isChannelDisabled(channel.id)">
                          <label :for="channel.id">
                            <span class="rental-name">{{ channel.name }}</span>
                          </label>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label for="schedule-payment-types" class="control-label">
                    {{ $t("automation.index.schedule_payment.payment_types") }}
                  </label>
                  <select name="schedule_payment_types" id="schedule-payment-types" v-model="schedulePayment.payment_type_id" class="form-control" @change="calculateRemainingAmount($event, schedulePayment.paymentItems[0])">
                    <option v-for="paymentType in paymentTypes" :value="paymentType.id">{{ paymentType.name }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row" v-for="(paymentItem, index) in schedulePayment.paymentItems">
              <div class="col-12">
                <div class="row">
                  <div class="col-12 d-flex justify-content-between align-items-center">
                    <h4 class="schedule-payment-title">
                      {{ paymentItem.is_remaining ? $t("automation.index.schedule_payment.modal.remaining_payment_title") : $t("automation.index.schedule_payment.modal.schedule_payment_title") }}
                    </h4>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    <div class="form-group">
                      <label class="control-label">
                        {{ $t("automation.index.modal.event_occur") }}
                      </label>
                      <span class="required">*</span>
                      <select type="text" class="form-control" v-model="paymentItem.action_occur_id"
                              @change="changeActionOccur(paymentItem)">
                        <option v-for="action_occur in action_occurs " :value="action_occur.id"> {{
                          $t('automation.index.'+action_occur.name) }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group">
                      <label class="control-label">
                        {{ $t("automation.index.modal.trigger_time") }}
                      </label>
                      <span class="required">*</span>
                      <select type="text" class="form-control" v-model="paymentItem.trigger_time" v-if="paymentItem.action_occur_id !== 20">
                        <option v-for="(trigger_time, index) in $t('trigger_times')" :value="trigger_time">
                          {{ (index != 0
                          ? paymentItem.signBeforeDays
                          : '') + trigger_time
                          }}
                        </option>
                        <option v-for="trigger_time in 365"
                                :value="`${trigger_time} ${(trigger_time === 1 ? $t('day') : $t('days'))}`">
                          {{
                            trigger_time == 1
                              ? `${paymentItem.signBeforeDays}${trigger_time} ${$t('day')}`
                              : `${paymentItem.signBeforeDays}${trigger_time} ${$t('days')}`
                          }}
                        </option>
                      </select>
                      <date-time-picker v-if="paymentItem.action_occur_id === 20" type="datetime" :lang="account.lang" :not-before="new Date()" ref="reminder-picker"
                                        :clearable="true" width="100%" class="form-control" id="specific-day" v-model="paymentItem.trigger_time"
                                        :show-second="'false'" format="YYYY-MM-DD HH:mm:ss">
                      </date-time-picker>
                    </div>
                  </div>
                  <div class="col-4" v-show="(!paymentItem.is_remaining && schedulePayment.payment_type_id === 1) || (schedulePayment.payment_type_id === 2)">
                    <div class="form-group">
                      <label class="control-label">
                        {{ $t("automation.index.schedule_payment.modal.payment_amount") }}
                      </label>
                      <span class="required">*</span>
                      <span v-show="schedulePayment.payment_type_id === 2"> (%)</span>
                      <input type="text" class="form-control" v-model="paymentItem.amount" @input="calculateRemainingAmount($event, paymentItem)" @keyup="calculateRemainingAmount($event, paymentItem)" :disabled="paymentItem.is_remaining == true">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center">
            <button :disabled="smallLoading" type="button" class="btn waves-effect waves-classic btn-cancel" id="modal-close" @click.prevent="closeScheduleModal()"
                    data-dismiss="modal">{{ $t("button.cancel") }}
            </button>
            <button :disabled="smallLoading" type="submit" class="btn btn-primary waves-effect waves-classic btn-save">{{ editData ? $t("button.update") : $t("button.save")}}</button>
            <v-loading v-bind:isLoading="smallLoading" v-bind:height="50" v-bind:width="50" v-bind:viewbox="'0 0 50 50'"
                       v-bind:cx="25" v-bind:cy="25" v-bind:r="22" v-bind:isHeightAuto="true"></v-loading>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from "vue";
  import mixin from "../../mixins/mixin";
  import schedulePaymentService from "../../services/schedule-payment";
  import DateTimePicker from 'vue2-datepicker';

  export default {
    name: "SchedulePaymentModal",
    data() {
      return {
        schedulePayment: {},
        defaultSchedulePayment: {
          payment_type_id: 1,
          rental_ids: [],
          channel_ids: [],
          paymentItems: [
            {
              action_occur_id: 1,
              trigger_time: 'Immediate',
              signBeforeDays: '+ ',
              is_remaining: false
            },
            {
              action_occur_id: 1,
              trigger_time: 'Immediate',
              signBeforeDays: '+ ',
              is_remaining: true
            }
          ],
        },
        areAllRentalsChecked: false,
        areAllChannelsChecked: false,
        smallLoading: false,
        checkedGroups: [],
        checkedRentals: [],
        editData: false,
        schedulePaymentGroupIds: [],
        tempCheckedRentalIds: [],
        tempAvailableRentalIds: [],
        tempCheckedChannelIds: [],
        tempAvailableChannelIds: [],
        language: localStorage.getItem('lang') || 'fr',
        immediateTiggerTimes: ['Immediate','Immédiat', 'Imediata', 'Inmediato'],
        days: ['Hours', 'Hour', 'Heures', 'Heure', 'Hora', 'Horas'],
      }
    },
    props: [
      'channels',
      'paymentTypes',
      'action_occurs',
      'groups',
      'rentals',
      'editSchedulePayment',
      'availableRentalIds',
      'selectedRentalIds',
      'selectedGroupIds',
      'selectedChannelIds',
      'availableChannelIds'
    ],
    mixins: [mixin],
    components: {
      VLoading: require('components/loading/loading.vue'),
      DateTimePicker
    },
    methods: {
      async createSchedulePayment() {
        this.smallLoading = true;
        await schedulePaymentService.store(this, this.schedulePayment);
        await this.getAllSchedulePayments();
        mixpanel.track('web.payments.create.schedule');
      },
      getSignBeforeDays(occurName, item) {
        const res = occurName.split('-');
        if (res && res[0] && res[1] && res[0] == 'before') {
          item.signBeforeDays = '- ';
        } else if (res && res[0] && res[1] && res[0] == 'after') {
          item.signBeforeDays = '+ ';
        } else {
          item.signBeforeDays = '';
        }
      },
      filterByRentals(id = null) {
        // todo change this part
        const vm = this;
        const rentals = [];
        if (id == 'all') {
          for (let j = 0; j < vm.groups.length; j++) {
            Vue.set(vm.checkedGroups, vm.groups[j].id, vm.areAllRentalsChecked);
            const groupRentals = vm.groups[j].rentals;
            for (let i = 0; i < groupRentals.length; i++) {
              Vue.set(vm.checkedRentals, groupRentals[i].id, vm.areAllRentalsChecked);
            }
          }
          this.$forceUpdate();
        } else if (id != null) {
          const group = vm.groups.filter(g => g.id === id)[0];
          const groupRentals = group.rentals;
          for (let i = 0; i < groupRentals.length; i++) {
            Vue.set(vm.checkedRentals, groupRentals[i].id, vm.checkedGroups[id]);
          }
          for (let j = 0; j < vm.groups.length; j++) {
            if (vm.groups[j] && vm.groups[j]['rentals'].length !== 0 && !vm.checkedGroups[vm.groups[j].id]) {
              vm.areAllRentalsChecked = false;
              break;
            }
            vm.areAllRentalsChecked = true;
          }
        } else {
          for (let i = 0; i < vm.groups.length; i++) {
            const group = vm.groups[i];
            for (let j = 0; j < group.rentals.length; j++) {
              const rental = group.rentals[j];
              if (!vm.checkedRentals[rental.id]) {
                Vue.set(vm.checkedGroups, group.id, false);
                break;
              }
              Vue.set(vm.checkedGroups, group.id, true);
            }
          }
          for (let j = 0; j < vm.groups.length; j++) {
            if (vm.groups[j] && vm.groups[j]['rentals'].length !== 0 && !vm.checkedGroups[vm.groups[j].id]) {
              vm.areAllRentalsChecked = false;
              break;
            }
            vm.areAllRentalsChecked = true;
          }
        }
        for (const k in vm.checkedRentals) {
          if (vm.checkedRentals[k] === true) {
            if (!vm.schedulePayment.rental_ids.includes(parseInt(k))) {
              this.tempCheckedRentalIds = this.tempCheckedRentalIds.concat(parseInt(k));
              const indexOfRental = vm.tempAvailableRentalIds.findIndex(id => id === parseInt(k));
              if (indexOfRental >= 0) {
                this.tempAvailableRentalIds.splice(indexOfRental, 1);
              }
            }
            rentals.push(parseInt(k));
          } else if (!vm.tempAvailableRentalIds.includes(parseInt(k))) {
            this.tempAvailableRentalIds = this.tempAvailableRentalIds.concat(parseInt(k));
            const indexOfRental = vm.tempCheckedRentalIds.findIndex(id => id === parseInt(k));
            if (indexOfRental >= 0) {
              this.tempCheckedRentalIds.splice(indexOfRental, 1);
            }
          }
        }
        vm.schedulePayment.rental_ids = rentals;
      },
      filterByChannels(id) {
        const vm = this;
        if (id === 'all') {
          vm.channels.map((channel) => {
            channel.is_checked = vm.areAllChannelsChecked;
            if (channel.is_checked) {
              if (!this.schedulePayment.channel_ids.includes(channel.id)) {
                vm.tempCheckedChannelIds = vm.tempCheckedChannelIds.concat(channel.id);
                const indexOfChannel = vm.tempAvailableChannelIds.findIndex(id => id === channel.id);
                if (indexOfChannel >= 0) {
                  vm.tempAvailableChannelIds.splice(indexOfChannel, 1);
                }
              }
            } else {
              vm.tempAvailableChannelIds = vm.tempAvailableChannelIds.concat(channel.id);
              const indexOfChannel = vm.tempCheckedChannelIds.findIndex(id => id === channel.id);
              if (indexOfChannel >= 0) {
                vm.tempCheckedChannelIds.splice(indexOfChannel, 1);
              }
            }
          });
        } else if (id) {
          const channel = vm.channels.find(channel => channel.id === id);
          if (channel.is_checked) {
            vm.tempCheckedChannelIds = vm.tempCheckedChannelIds.concat(channel.id);
            const indexOfChannel = vm.tempAvailableChannelIds.findIndex(id => id === channel.id);
            if (indexOfChannel >= 0) {
              vm.tempAvailableChannelIds.splice(indexOfChannel, 1);
            }
          } else {
            vm.tempAvailableChannelIds = vm.tempAvailableChannelIds.concat(channel.id);
            const indexOfChannel = vm.tempCheckedChannelIds.findIndex(id => id === channel.id);
            if (indexOfChannel >= 0) {
              vm.tempCheckedChannelIds.splice(indexOfChannel, 1);
            }
          }
        }
        vm.schedulePayment.channel_ids = vm.channels.filter(channel => channel.is_checked === true).map(channel => channel.id);
        if (this.schedulePayment.channel_ids.length === this.channels.length) {
          vm.areAllChannelsChecked = true;
        } else {
          vm.areAllChannelsChecked = false;
        }
      },
      changeActionOccur(item) {
        if (item.action_occur_id === 20) {
          item.trigger_time = null;
        } else {
          const triggerTimes = this.$t('trigger_times');
          if (triggerTimes && !triggerTimes.includes(item.trigger_time)) {
            item.trigger_time = triggerTimes[0];
          }
          const index = this.action_occurs.findIndex(x => x.id === item.action_occur_id);
          if (index !== -1) {
            const name = this.action_occurs[index].name;
            this.getSignBeforeDays(name, item);
          } else {
            item.signBeforeDays = '';
          }
        }
      },
      calculateRemainingAmount(event, item) {
        const maximum = 100;
        const remaining = this.schedulePayment.paymentItems.find(remainingItem => remainingItem.is_remaining == true);
        const amount = item.amount;

        if (this.schedulePayment.payment_type_id === 2) {
          if (amount > maximum && event.keyCode !== 46 && event.keyCode !== 8) {
            remaining.amount = 0;
            event.preventDefault();
            item.amount = maximum;
          } else if (amount < 0) {
            remaining.amount = null;
          } else {
            if (amount) {
              remaining.amount = maximum - amount;
            } else {
              remaining.amount = null;
            }
          }
        } else {
          remaining.amount = null;
        }
      },
      newSchedulePayment() {
        this.schedulePayment = JSON.parse(JSON.stringify(this.defaultSchedulePayment));
        this.checkedRentals = [];
        this.checkedGroups = [];
        this.areAllRentalsChecked = false;
        this.tempCheckedRentalIds = this.selectedRentalIds.slice(0);
        this.tempAvailableRentalIds = this.availableRentalIds.slice(0);
        this.tempCheckedChannelIds = this.selectedChannelIds.slice(0);
        this.tempAvailableChannelIds = this.availableChannelIds.slice(0);
        this.channels.map(channel => channel.is_checked = false);
        this.schedulePayment.paymentItems.map(item => item.trigger_time = this.$t('trigger_times')[0]);
      },
      edit(paymentItem) {
        const {channel_ids, payment_items, payment_type_id, rental_ids, title, status} = paymentItem;
        this.schedulePayment = {
          id: paymentItem.id,
          title,
          payment_type_id,
          rental_ids,
          channel_ids,
          paymentItems: payment_items,
          status
        };

        this.schedulePayment.paymentItems.map(item => {
          const occur = this.action_occurs.find(occur => occur.id === item.action_occur_id);

          if (this.immediateTiggerTimes.includes(item.trigger_time)) {
            item.trigger_time = this.$t('trigger_times')[0];
          } else if (item.action_occur_id !== 20) {
            item.trigger_time = this.getTriggerTimeName(item.trigger_time, occur.name, this.days)
          }

          if (item.trigger_time !== this.$t('trigger_times')[0]) {
            this.getSignBeforeDays(occur.name, item);
          } else {
            item.signBeforeDays = '+ ';
          }
        });
        this.tempCheckedRentalIds = this.selectedRentalIds.slice(0);
        this.tempAvailableRentalIds = this.availableRentalIds.slice(0);
        this.tempCheckedChannelIds = this.selectedChannelIds.slice(0);
        this.tempAvailableChannelIds = this.availableChannelIds.slice(0);

        if (this.channels && this.channels.length === channel_ids.length) {
          this.areAllChannelsChecked = true;
          this.channels.map(channel => channel.is_checked = true);
        } else {
          this.areAllChannelsChecked = false;
          this.channels.map(channel => channel.is_checked = false);
          this.schedulePayment.channel_ids.map(id => {
            let channel = this.channels.find(ch => ch.id === id);
            if (channel) {
              channel.is_checked = true;
            }
          });
        }
        if (this.rentals.length === rental_ids.length) {
          this.areAllRentalsChecked = true;
          rental_ids.map(id => this.checkedRentals[id] = true);
          this.groups.map((group) => {
            this.checkedGroups[group.id] = true;
          });
        } else {
          this.checkedRentals = [];
          this.checkedGroups = [];
          this.areAllRentalsChecked = true;
          rental_ids.map(id => this.checkedRentals[id] = true);
          this.groups.map(group => {
            let count = 0;
            if (group.rentals) {
              group.rentals.map(rental => {
                rental_ids.map(id => {
                  if (rental.id === id) {
                    count++;
                  }
                });
              });
              if (count === group.rentals.length) {
                this.checkedGroups[group.id] = true;
              } else {
                this.areAllRentalsChecked = false;
              }
            }
          });
        }

        this.schedulePaymentGroupIds = [];
        const scheduleRentalIds = this.schedulePayment.rental_ids;
        let schedulePaymentGroups = [];

        if (scheduleRentalIds.length > 0) {
          schedulePaymentGroups = this.groups.filter(group => {
            if (group.rentals) {
              const selectedRentals = group.rentals.filter(rental => scheduleRentalIds.includes(rental.id));
              if (selectedRentals.length > 0) {
                return group;
              }
            }
          });
        } else {
          schedulePaymentGroups = this.groups;
        }
        if (schedulePaymentGroups.length > 0) {
          const schedulePaymentGroupIds = schedulePaymentGroups.map(group => group.id);
          this.schedulePaymentGroupIds = this.schedulePaymentGroupIds.concat(schedulePaymentGroupIds);
        }
      },
      async updateSchedulePayment() {
        this.smallLoading = true;
        await schedulePaymentService.update(this, this.schedulePayment);
        await this.getAllSchedulePayments();
      },
      getAllSchedulePayments() {
        this.$emit('getAllSchedulePayments');
      },
      isGroupDisabled(groupId) {
        if (this.editData) {
          let disableGroup = false;
          const group = this.groups.find(group => group.id === groupId);
          if (group && group.rentals) {
            const alreadySelectedRentals = group.rentals.filter(rental => this.tempCheckedRentalIds.includes(rental.id) && !this.schedulePayment.rental_ids.includes(rental.id));
            if (alreadySelectedRentals.length > 0) {
              disableGroup = true;
            }
          }
          return disableGroup;
        } else if (this.selectedGroupIds.includes(groupId) && !this.editData) {
          return true;
        }
      },
      isRentalDisabled(rentalId) {
        if (this.editData && !this.schedulePayment.rental_ids.includes(rentalId) && !this.tempAvailableRentalIds.includes(rentalId)) {
            return true;
        } else if (!this.editData && this.tempCheckedRentalIds.includes(rentalId) && !this.schedulePayment.rental_ids.includes(rentalId)) {
            return true;
        }
      },
      isRentalAllDisabled() {
        if (this.tempCheckedRentalIds.length > 0) {
          const alreadyCheckedRentals = this.tempCheckedRentalIds.filter(id => !this.schedulePayment.rental_ids.includes(id));
          if (alreadyCheckedRentals.length > 0) {
            return true;
          }
        }
      },
      isChannelDisabled(channelId) {
        if (!this.editData && this.tempCheckedChannelIds.includes(channelId) && !this.schedulePayment.channel_ids.includes(channelId)) {
          return true;
        } else if (this.editData && !this.tempAvailableChannelIds.includes(channelId) && !this.schedulePayment.channel_ids.includes(channelId)) {
          return true;
        }
      },
      isChannelAllDisabled() {
        if (this.tempCheckedChannelIds.length > 0) {
          const alreadyCheckedChannels = this.tempCheckedChannelIds.filter(id => !this.schedulePayment.channel_ids.includes(id));
          if (alreadyCheckedChannels.length > 0) {
            return true;
          }
        }
      },
      closeScheduleModal() {
        this.areAllChannelsChecked = false;
        this.closeModal('#schedule-payment-modal');
      },
    },
    watch: {
      editSchedulePayment: function (paymentItem) {
        if (paymentItem && Object.values(paymentItem).length > 0) {
          this.editData = true;
          this.edit(paymentItem);
        } else {
          this.editData = false;
          this.newSchedulePayment();
        }
      }
    },
    computed: {
      account: function () {
        return this.$store.state.account;
      },
    }
  }
</script>



// WEBPACK FOOTER //
// SchedulePaymentModal.vue?6c96c747